import { RootState } from '@iwProvider/configureStore';
import { GetDrawDownRepaymentScheduleCreditFacilityResponse } from '@iwoca/lapi-client/edge';
import _ from 'lodash';

const getDrawdownRepaymentSchedule = (state: RootState) => {
    const creditFacilityRepaymentSchedule = _.get(
        state,
        'api.draw_down_repayment_schedule.data.schedule',
        null
    );
    //some parts of code is still using credit_facility_repayment_schedule, we need to phase it out.

    return creditFacilityRepaymentSchedule
        ? creditFacilityRepaymentSchedule
        : _.get(state, 'api.draw_down_repayment_schedule.data.schedule', []);
};

const getDrawdownRepaymentSummary = (state: RootState) => {
    const creditFacilityRepaymentSummary = _.get(
        state,
        'api.draw_down_repayment_schedule.data.summary',
        null
    );
    //some parts of code is still using credit_facility_repayment_schedule, we need to phase it out.

    return creditFacilityRepaymentSummary
        ? creditFacilityRepaymentSummary
        : _.get(state, 'api.draw_down_repayment_schedule.data.summary', null);
};

export const getDrawdownNextRepaymentAmount = (state: RootState) => {
    const repaymentSchedule = getDrawdownRepaymentSchedule(state);
    return _.get(repaymentSchedule, '[0].total');
};

export const getDrawdownNextRepaymentDate = (state: RootState) => {
    const repaymentSchedule = getDrawdownRepaymentSchedule(state);
    return _.get(repaymentSchedule, '[0].date');
};

export const getDrawdownTotalBalance = (state: RootState) => {
    const repaymentSummary = getDrawdownRepaymentSummary(state);
    return _.get(repaymentSummary, 'total_payable', 0);
};

export const getDrawdownEqualRepaymentAmount = (state: RootState) => {
    const repaymentSummary = getDrawdownRepaymentSummary(state);
    return _.get(
        repaymentSummary,
        'simplified_schedule.equal_repayments.amount',
        0
    );
};

export const finalMonthsRepaymentAmount = (state: RootState) => {
    const repaymentSchedule = getDrawdownRepaymentSchedule(state);
    return repaymentSchedule?.[repaymentSchedule.length - 1]?.total || 0;
};

export const getDrawdownFees = (state: RootState) => {
    const repaymentSummary = getDrawdownRepaymentSummary(state);
    return _.get(repaymentSummary, 'total_fees', 0);
};

export const getDrawdownTotalInterest = (state: RootState) => {
    const repaymentSchedule = getDrawdownRepaymentSchedule(
        state
    ) as GetDrawDownRepaymentScheduleCreditFacilityResponse['data']['schedule'];
    return repaymentSchedule.reduce(
        (totalInterest, repayment) => totalInterest + repayment.interest,
        0
    );
};

export const calculateDrawdownTotalInterest = (
    repaymentSchedule: GetDrawDownRepaymentScheduleCreditFacilityResponse['data']['schedule']
) => {
    return repaymentSchedule.reduce(
        (totalInterest, repayment) => totalInterest + repayment.interest,
        0
    );
};
